"use client"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="ja">
      <body>
        <div>
          Global Error occurred.
          <br />
          <button type="button" onClick={() => reset()}>
            Try again.
          </button>
        </div>
      </body>
    </html>
  )
}
